import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import DF from 'DisplayFramework';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DataGrid from 'components/DataGrid';
import { notification, Form, Button as AntButton, Popconfirm, Row } from 'antd';
import {
  PlusOutlined,
  AppstoreTwoTone,
  CloseOutlined,
} from '@ant-design/icons';
import { useForm } from 'antd/lib/form/Form';
import { indexBy, setValueByNamePath, shouldUpdateCompare } from 'utils/utils2';
// import SaveButtonIcon from 'components/SaveBtn';
import { useFormList } from 'hooks/useFormList';
// import EditButton from 'components/EditButton';
import { AuthContext } from 'components/Auth/Auth';
import {
  AssetCatalogUpgradeResponse,
  ParAssetCatalogUpgrade,
  addAssetCatalogUpgrade,
  removeAssetCatalogUpgrade,
} from 'services/assetconfig';
import { toCurrency } from 'utils/utils';
import ModalController from 'components/ModalController';
import ModalControllerNV from 'components/ModalControllerNV';
import AssetCatalogSearchModal from './AssetCatalogSearchModal';
import UpdateButton from 'components/UpdateButtonAction';
import { isNil } from 'lodash';
import AssetCatalogDetailsModal from './AssetCatalogDetailsModal';
import DeleteButton from 'components/DeleteButton';
import Button from 'components/Button';

type AsseCatalogUpgradeListProps = {
  catalogid: number;
  isModal?: string;
  UpgradeList:any
  refetch: any;
};
const AssetCatalogUpgradeList = (props: AsseCatalogUpgradeListProps) => {
  const { catalogid, isModal,UpgradeList,refetch } = props;
  const [form] = useForm();
  const fieldName = 'upgrades';
  const NEW_UP_ID = -1;
  const { isInspect } = useContext(AuthContext);

  const [editingKeys, setEditingKeys] = useState<number | null>();
  const isEditable = (upid: number): boolean => editingKeys !== upid;


  const { add, remove } = useFormList(form, fieldName, {
    idKey: 'upid',
    addAsFirst: true,
  });
  useEffect(() => {
    if (UpgradeList) {
      form.setFieldsValue({
        [fieldName]: UpgradeList.map((up: AssetCatalogUpgradeResponse) => ({
          ...up,
          catalogidupgrade: up.catalogid,
          assetlabel: up.assetlabel,
          assetnetamount: up.assetnetamount,
        })),
      });
    }
  }, [form, UpgradeList]);
  const getName = useCallback(
    (name: string) => (record: ParAssetCatalogUpgrade) => {
      const actions = form.getFieldValue(fieldName);
      const index = indexBy(actions, 'upid')[record.upid];
      return [fieldName, index, name];
    },
    [form]
  );

  const onSaveOrEdit = async (values: ParAssetCatalogUpgrade) => {
    const requestPaylod = {
      ...values,
    };
    if (requestPaylod.upid === NEW_UP_ID) {
      addAssetCatalogUpgrade({
        req: {
          ...requestPaylod,
        },
        catalogid: catalogid,
      }).then((response) => {
        if (response.code === '200') {
          notification.success({ message: response.message });
          setEditingKeys(null);
          refetch();
        } else {
          notification.error({ message: response.message });
        }
      });
    }
  };

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'catalogidupgrade',
        render: (value, record) => {
          return (
            <Form.Item name={getName('catalogidupgrade')(record)} noStyle>
              {value}
              {record?.upid === NEW_UP_ID ? (
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <AntButton
                      icon={<AppstoreTwoTone />}
                      onClick={() => setVisible(true)}
                      size="small"
                      style={{ marginLeft: '9px' }}
                    />
                  )}
                  modal={({ setVisible, visible }) => (
                    <AssetCatalogSearchModal
                      visible={visible}
                      onCancel={() => {
                        setVisible(false);
                      }}
                      setAsset={(asset) => {
                        form.setFieldsValue({
                          catalogidupgrade: asset.catalogid,
                          assetlabel: asset.assetlabel,
                          currcode: asset.currcode,
                          assetnetamount: asset.assetnetamount,
                        });
                        setValueByNamePath(
                          form,
                          getName('catalogidupgrade')(record),
                          asset.catalogid
                        );
                        setValueByNamePath(
                          form,
                          getName('assetlabel')(record),
                          asset.assetlabel
                        );
                        setValueByNamePath(
                          form,
                          getName('currcode')(record),
                          asset.currcode
                        );
                        setValueByNamePath(
                          form,
                          getName('assetnetamount')(record),
                          asset.assetnetamount
                        );

                        setVisible(false);
                      }}
                    />
                  )}
                ></ModalControllerNV>
              ) : (
                ''
              )}
            </Form.Item>
          );
        },
        width: 20,
      },
      {
        dataIndex: 'assetlabel',
        render: (value, record) => {
          return (
            record !== undefined && (
              <Form.Item name={getName('assetlabel')(record)} noStyle>
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>{value}</a>
                      <AssetCatalogDetailsModal
                        title={record.assetlabel}
                        catalogid={record.catalogidupgrade}
                        visible={visible}
                        onCancel={() => setVisible(false)}
                      />
                    </>
                  )}
                </ModalController>
              </Form.Item>
            )
          );
        },
        width: 40,
      },
      {
        dataIndex: 'assetnetamount',
        width: 20,
        render: (value, record) => (
          <Form.Item shouldUpdate={shouldUpdateCompare('currcode')} noStyle>
            {toCurrency(value, record.currcode)}
          </Form.Item>
        ),
      },

      {
        dataIndex: 'Actions',
        width: 25,
        fixed: 'right',
        render: (_, record) => {
          return record.upid === NEW_UP_ID ? (
            <>
              <UpdateButton
                comcode="save"
                htmlType="button"
                size="middle"
                onClick={() => {
                  !isInspect && onSaveOrEdit(record);
                }}
              />
              <AntButton
                danger
                htmlType="button"
                icon={
                  <CloseOutlined height="14px" width="14px" color="white" />
                }
                onClick={() => {
                  !isInspect && remove(record.upid);
                }}
              />
            </>
          ) : (
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => {
                removeAssetCatalogUpgrade({
                  catalogid: record.catalogid,
                  upid: record.upid,
                }).then((res) => {
                  notification.success({ message: res.message });
                 
                });
              }}
            >
              <DeleteButton onlyIcon />
            </Popconfirm>
          );
        },
      },
    ],
    [form,  getName, editingKeys]
  );

  const addRow = () => {
    const row: ParAssetCatalogUpgrade = {
      catalogidupgrade: '' as any,
      upid: NEW_UP_ID,
      catalogid: catalogid,
    };
    add(row);
    setEditingKeys(-1);
  };

  return (
    <DF.Provider pagcode="upgradeslist">
      <Form form={form}>
        <Form.Item noStyle shouldUpdate={shouldUpdateCompare(fieldName)}>
          {({ getFieldValue }) => {
            const upgrade: ParAssetCatalogUpgrade[] = getFieldValue(fieldName);
            const isNewItemInTable =
              upgrade?.find(({ upid }) => upid === NEW_UP_ID) !== undefined;
            return (
              <DataGrid
                rowKey="upid"
                columns={columns}
                dataSource={upgrade}
                hideFilters
                titleComcode="UpgradeList"
                extraActions={
                  isModal ? (
                    <Row style={{ height: 45 }} />
                  ) : (
                    <Button
                      type="primary"
                      disabled={isNewItemInTable}
                      icon={<PlusOutlined />}
                      onClick={() => !isInspect && addRow()}
                      comcode="Add"
                      hidden={isNil(catalogid)}
                      style={{ height: 40, width: 100 }}
                    />
                  )
                }
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default AssetCatalogUpgradeList;
